import React, { useState } from "react";
import { Switch, Table, Modal, Space, Avatar, Image } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import IntlMessages from "../../../../util/IntlMessages";
import { PageSize } from "src/apis/helpers/configs/page-sizes";
import { useGetProjects } from "src/hooks/services/projects/useGetProjects";
import { useDeleteProjects } from "src/hooks/services/projects/useDeleteProjects";
const confirm = Modal.confirm;
const { Column } = Table;
const List = (props) => {
  const [page, setPage] = useState(1);
  const { data: ProjectsData, isLoading } = useGetProjects();
  const { mutate: onDeleteProjects } = useDeleteProjects();

  const changePage = (page) => {
    setPage(page);
  };

  const editProjects = (data) => {
    props.changeTabEvent("2", data); // raftan be tab edit
  };

  const showDeleteConfirm = (data) => {
    confirm({
      title: "آیا اطمینان دارید از حذف این پروژه ؟",
      okText: "بله",
      okType: "danger",
      cancelText: "خیر",
      onOk() {
        onDeleteProjects(data.projectId, {
          onSuccess: (data) => {
            toast.success(
              <IntlMessages id="notification.successMessage" />
            );
          },
          onError: (err:any) => {
            toast.error(
              err.message
            );
          },
        });
      },
      onCancel() { },
    });
  };

  return (
    <>
      <Table
        className="gx-table-responsive"
        dataSource={ProjectsData}
        rowKey="ProjectsId"
      >
        <Column
          title="عکس"
          dataIndex="projectImage"
          key="projectImage"
          render={(text, record: any) => (
            <Avatar shape="square" size={80} src={<Image src={record.projectImage} />} />
          )}
        />
        <Column title="عنوان" dataIndex="projectTitle" key="projectTitle" />
        <Column title="توضیح کوتاه" dataIndex="projectLead" key="projectLead" />
        <Column
          title="ویرایش"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => editProjects(record)}>ویرایش</a>
            </Space>
          )}
        />
        <Column
          title="حذف"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => showDeleteConfirm(record)}>حذف</a>
            </Space>
          )}
        />
      </Table>
       {/* <NotificationContainer /> */}
    </>
  );
};

export default List;
